import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FileUploadInput from '../common/FileUploadInput';

const FileUploadDialog = props => {
  const { patientId, leadId, dialogIsOpen, onClose, afterSubmit } = props;
  return (
    <Dialog
      open={dialogIsOpen}
      fullWidth={true}
      maxWidth='md'
      onClose={onClose}
    >
      <DialogContent style={{padding: 0}}>
        <Stack spacing={2} padding={2} alignItems='center'>
          <Typography variant='h3'>
            Upload a File
          </Typography>
          <FileUploadInput
            label='Upload a File'
            fileType='patient_file'
            patientId={patientId}
            leadId={leadId}
            allowTitle={true}
            allowDescription={false}
            titlePlaceholder={'J. Smith. Medical History. 1/30/2025'}
            titleHelperText='Patient First Initial. Patient Last Name. Title of Document. Date'
            afterSubmit={() => onClose()}
            // screen={'foo'} // WEIRD
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default FileUploadDialog;